// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"9c4b9151","209":"e1f55257","250":"3ef71db9","482":"a12f0077","562":"e9bc5061","625":"df8b3bc4","745":"b5c83463","887":"34307ef3","922":"a9748d02","964":"b5712604"}[chunkId] + ".chunk.js";
};